<script>
import Component from '~/sites/shop/pages/index'
export default {
  extends: Component,
}
</script>
